<script lang="ts" setup>
import { formatCurrency } from "@/utils/number";
import { CorporationSalarySummary } from "@/types/balance/BalanceHistory";
import { PropType } from "vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";

const props = defineProps({
  corporationSalarySummaries: {
    type: Array as PropType<CorporationSalarySummary[]>,
    required: true
  }
});
const emits = defineEmits(["clickDetail"]);

function onClickDetail(corporationSalarySummary: CorporationSalarySummary) {
  emits("clickDetail", corporationSalarySummary);
}
</script>
<template>
  <div class="border-top border-outline-color">
    <div
      v-for="corporationSalarySummary in props.corporationSalarySummaries"
      :key="'corporation-summary' + corporationSalarySummary.corporationId"
      class="bg-white border-bottom border-outline-color"
    >
      <div
        class="detail-item"
        @click="onClickDetail(corporationSalarySummary)"
        data-testid="detail-item"
      >
        <span class="corporation-label" data-testid="corporation-label">{{
          corporationSalarySummary.name
        }}</span>
        <div class="d-flex align-items-center flex-grow-0">
          <span
            class="text-size-14 text-weight-600 text-blue"
            data-testid="total-income"
          >
            {{ formatCurrency(corporationSalarySummary.totalIncome) }}
          </span>
          <FeatherIcon
            icon="chevron-right"
            size="1x"
            class="text-gray-05 ml-1"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.detail-item {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
}

.corporation-label {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
}

.space {
  width: 20px;
}
</style>
